import {FormioBase} from "./formiobase";

export class Email extends FormioBase {
  public inputType = "email";
  public title = "Email";
  public icon = "fa fa-at";
  public schema: any = {
    title: "email",
    components: [{
      input: true,
      tableView: true,
      inputType: "email",
      label: "Email",
      key: "emailField1",
      placeholder: "",
      prefix: "",
      suffix: "",
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      clearOnHide: true,
      notvisible: false,
      kickbox: {
        enabled: false,
      },
      type: "email",
      tags: [],
      validate: {
        required: false,
        minLength: 0,
        maxLength: 255,
      },
      description: "",
      tooltip: "",
      customClass: "ds-email",
    }],
  };
}
